module.exports = __webpack_public_path__ + "static/media/firstWitnessSpanish.80bc57e9.webp";